import { render, staticRenderFns } from "./biddingDialog.vue?vue&type=template&id=3ee5e187&scoped=true"
import script from "./biddingDialog.vue?vue&type=script&lang=js"
export * from "./biddingDialog.vue?vue&type=script&lang=js"
import style0 from "./biddingDialog.vue?vue&type=style&index=0&id=3ee5e187&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5e187",
  null
  
)

export default component.exports